export const NODE_CONSTANT = {
  NODE_TYPE_FILE: 'cm:content',
  NODE_TYPE_LOCK: 'cm:lockType',
  WRITE_LOCK: 'WRITE_LOCK',
  SITE_COMPONENT_ID: 'st:componentId',
  SITES: 'Sites',
};
